module.exports = "<input [(ngModel)]=\"term\" (ngModelChange)=\"search($event)\" class=\"form-control\" placeholder=\"Cerca...\" />"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/search/search.component.html
// module id = ./src/app/components/search/search.component.html
// module chunks = main